module.exports = __webpack_public_path__ + "img/wangShangBink.03568e38.png";